import { CheckinSkillLevelLabel } from 'components/checkin-skill-level-label'
import { CheckinStatusLabel } from 'components/checkin-status-label'
import { CheckinSummaryPage } from 'pages/checkin-summary-page'
import { forRails } from 'components/for-rails'
import { registerComponents } from '../src/utils/react/registry'
import { UpdatesDrawer } from 'components/updates-drawer'
import { UpdatesDrawerButton } from 'components/updates-drawer-button'
import { ArchivedCheckinsPage } from 'pages/archived-checkins-page'
import { ArchivedCheckinDetailsPage } from 'pages/archived-checkin-details-page'
import { CheckinsPage } from 'pages/checkins-page'
import { CheckinUploadAttachments } from 'components/attachments/checkin-upload-attachments'
import { AttachmentDisplay } from 'components/attachments/display-attachment'
import { Toaster } from 'react-hot-toast'
import { SkillLevelIndicator } from 'components/skill-level-indicator'

registerComponents({
  ArchivedCheckinDetailsPage: forRails(ArchivedCheckinDetailsPage),
  ArchivedCheckinsPage: forRails(ArchivedCheckinsPage),
  CheckinsPage: forRails(CheckinsPage),
  CheckinSkillLevelLabel: forRails(CheckinSkillLevelLabel),
  CheckinStatusLabel: forRails(CheckinStatusLabel),
  CheckinSummaryPage: forRails(CheckinSummaryPage),
  UpdatesDrawer: forRails(UpdatesDrawer),
  UpdatesDrawerButton: forRails(UpdatesDrawerButton),
  CheckinUploadAttachments: forRails(CheckinUploadAttachments),
  AttachmentDisplay: forRails(AttachmentDisplay),
  Toaster: forRails(Toaster),
  SkillLevelIndicator: forRails(SkillLevelIndicator),
})
